import { LuggageAmounteServiceClass } from "./LuggageAmounteServiceClass.model";

export class TravelMixData
{
    id:number;
    name:string;
    airportConnection:boolean;
    harbourConnection:boolean;
    regionId:number;
    seasonIds:number[];
    transportModeIds:number[];
    luggageAmounteServiceClasses:LuggageAmounteServiceClass[];
    isMarkedAsDelete:boolean=false;
}
